// extracted by mini-css-extract-plugin
export default {"container":"DialogNotifications_container__L9Dxw"};